import type { Preset } from '@primeuix/themes/types';
import type { AuraBaseDesignTokens } from './base/index.d';

import accordion from '@primeuix/themes/aura/accordion';
import autocomplete from '@primeuix/themes/aura/autocomplete';
import avatar from '@primeuix/themes/aura/avatar';
import badge from '@primeuix/themes/aura/badge';
import base from '@primeuix/themes/aura/base';
import blockui from '@primeuix/themes/aura/blockui';
import breadcrumb from '@primeuix/themes/aura/breadcrumb';
import button from '@primeuix/themes/aura/button';
import card from '@primeuix/themes/aura/card';
import carousel from '@primeuix/themes/aura/carousel';
import cascadeselect from '@primeuix/themes/aura/cascadeselect';
import checkbox from '@primeuix/themes/aura/checkbox';
import chip from '@primeuix/themes/aura/chip';
import colorpicker from '@primeuix/themes/aura/colorpicker';
import confirmdialog from '@primeuix/themes/aura/confirmdialog';
import confirmpopup from '@primeuix/themes/aura/confirmpopup';
import contextmenu from '@primeuix/themes/aura/contextmenu';
import css from '@primeuix/themes/aura/css';
import datatable from '@primeuix/themes/aura/datatable';
import dataview from '@primeuix/themes/aura/dataview';
import datepicker from '@primeuix/themes/aura/datepicker';
import dialog from '@primeuix/themes/aura/dialog';
import divider from '@primeuix/themes/aura/divider';
import dock from '@primeuix/themes/aura/dock';
import drawer from '@primeuix/themes/aura/drawer';
import editor from '@primeuix/themes/aura/editor';
import fieldset from '@primeuix/themes/aura/fieldset';
import fileupload from '@primeuix/themes/aura/fileupload';
import floatlabel from '@primeuix/themes/aura/floatlabel';
import galleria from '@primeuix/themes/aura/galleria';
import iconfield from '@primeuix/themes/aura/iconfield';
import iftalabel from '@primeuix/themes/aura/iftalabel';
import image from '@primeuix/themes/aura/image';
import imagecompare from '@primeuix/themes/aura/imagecompare';
import inlinemessage from '@primeuix/themes/aura/inlinemessage';
import inplace from '@primeuix/themes/aura/inplace';
import inputchips from '@primeuix/themes/aura/inputchips';
import inputgroup from '@primeuix/themes/aura/inputgroup';
import inputnumber from '@primeuix/themes/aura/inputnumber';
import inputotp from '@primeuix/themes/aura/inputotp';
import inputtext from '@primeuix/themes/aura/inputtext';
import knob from '@primeuix/themes/aura/knob';
import listbox from '@primeuix/themes/aura/listbox';
import megamenu from '@primeuix/themes/aura/megamenu';
import menu from '@primeuix/themes/aura/menu';
import menubar from '@primeuix/themes/aura/menubar';
import message from '@primeuix/themes/aura/message';
import metergroup from '@primeuix/themes/aura/metergroup';
import multiselect from '@primeuix/themes/aura/multiselect';
import orderlist from '@primeuix/themes/aura/orderlist';
import organizationchart from '@primeuix/themes/aura/organizationchart';
import overlaybadge from '@primeuix/themes/aura/overlaybadge';
import paginator from '@primeuix/themes/aura/paginator';
import panel from '@primeuix/themes/aura/panel';
import panelmenu from '@primeuix/themes/aura/panelmenu';
import password from '@primeuix/themes/aura/password';
import picklist from '@primeuix/themes/aura/picklist';
import popover from '@primeuix/themes/aura/popover';
import progressbar from '@primeuix/themes/aura/progressbar';
import progressspinner from '@primeuix/themes/aura/progressspinner';
import radiobutton from '@primeuix/themes/aura/radiobutton';
import rating from '@primeuix/themes/aura/rating';
import ripple from '@primeuix/themes/aura/ripple';
import scrollpanel from '@primeuix/themes/aura/scrollpanel';
import select from '@primeuix/themes/aura/select';
import selectbutton from '@primeuix/themes/aura/selectbutton';
import skeleton from '@primeuix/themes/aura/skeleton';
import slider from '@primeuix/themes/aura/slider';
import speeddial from '@primeuix/themes/aura/speeddial';
import splitbutton from '@primeuix/themes/aura/splitbutton';
import splitter from '@primeuix/themes/aura/splitter';
import stepper from '@primeuix/themes/aura/stepper';
import steps from '@primeuix/themes/aura/steps';
import tabmenu from '@primeuix/themes/aura/tabmenu';
import tabs from '@primeuix/themes/aura/tabs';
import tabview from '@primeuix/themes/aura/tabview';
import tag from '@primeuix/themes/aura/tag';
import terminal from '@primeuix/themes/aura/terminal';
import textarea from '@primeuix/themes/aura/textarea';
import tieredmenu from '@primeuix/themes/aura/tieredmenu';
import timeline from '@primeuix/themes/aura/timeline';
import toast from '@primeuix/themes/aura/toast';
import togglebutton from '@primeuix/themes/aura/togglebutton';
import toggleswitch from '@primeuix/themes/aura/toggleswitch';
import toolbar from '@primeuix/themes/aura/toolbar';
import tooltip from '@primeuix/themes/aura/tooltip';
import tree from '@primeuix/themes/aura/tree';
import treeselect from '@primeuix/themes/aura/treeselect';
import treetable from '@primeuix/themes/aura/treetable';
import virtualscroller from '@primeuix/themes/aura/virtualscroller';

export default {
    ...base,
    components: {
        accordion,
        autocomplete,
        avatar,
        badge,
        blockui,
        breadcrumb,
        button,
        card,
        carousel,
        cascadeselect,
        checkbox,
        chip,
        colorpicker,
        confirmdialog,
        confirmpopup,
        contextmenu,
        datatable,
        dataview,
        datepicker,
        dialog,
        divider,
        dock,
        drawer,
        editor,
        fieldset,
        fileupload,
        floatlabel,
        galleria,
        iconfield,
        iftalabel,
        image,
        imagecompare,
        inlinemessage,
        inplace,
        inputchips,
        inputgroup,
        inputnumber,
        inputotp,
        inputtext,
        knob,
        listbox,
        megamenu,
        menu,
        menubar,
        message,
        metergroup,
        multiselect,
        orderlist,
        organizationchart,
        overlaybadge,
        paginator,
        panel,
        panelmenu,
        password,
        picklist,
        popover,
        progressbar,
        progressspinner,
        radiobutton,
        rating,
        ripple,
        scrollpanel,
        select,
        selectbutton,
        skeleton,
        slider,
        speeddial,
        splitbutton,
        splitter,
        stepper,
        steps,
        tabmenu,
        tabs,
        tabview,
        tag,
        terminal,
        textarea,
        tieredmenu,
        timeline,
        toast,
        togglebutton,
        toggleswitch,
        toolbar,
        tooltip,
        tree,
        treeselect,
        treetable,
        virtualscroller
    },
    css
} satisfies Preset<AuraBaseDesignTokens>;
